// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3L0J2","gfeWrapper":"CalendarEvent_gfeWrapper__3j22Y"};